import Card from "../components/Card";

export default function Landing() {
  return (
    <main className="landing-screen">
      <div className="landing-container">
        <header className="landing-hero">
          <img
            src="/eagle-delivery-logo.jpg"
            alt="Eagle Delivery"
            className="landing-logo"
            width={280}
            height={224}
          />
          <img
            src="/eagle-dispatch-logo.jpg"
            alt="Eagle Dispatch"
            className="landing-logo-secondary"
            width={474}
            height={90}
          />
          <p className="landing-value">
            Dispatch and driver operations console for Eagle Hauling &amp; Recycling.
          </p>
        </header>

        <section className="landing-section">
          <Card className="landing-contact-card">
            <h2>Contact Eagle Hauling &amp; Recycling INC</h2>
            <div className="landing-contact-list">
              <div className="landing-contact-item">
                <span className="contact-label">Phone</span>
                <a href="tel:+18315945858" className="contact-link">
                  (831) 594-5858
                </a>
              </div>
              <div className="landing-contact-item">
                <span className="contact-label">Web</span>
                <a href="https://www.eaglehauling.com" className="contact-link">
                  www.eaglehauling.com
                </a>
              </div>
              <div className="landing-contact-item">
                <span className="contact-label">Address</span>
                <span className="contact-link" style={{ cursor: "default" }}>
                  P.O. Box 3037 Salinas, CA 93912
                </span>
              </div>
            </div>
          </Card>
        </section>

        <section className="landing-section">
          <div className="landing-entries">
            <span className="entries-label">System Access</span>
            <div className="entry-links">
              <span className="entry-note">
                For system access please contact{" "}
                <a href="mailto:chuck@eaglehauling.com">chuck@eaglehauling.com</a>
              </span>
            </div>
          </div>
        </section>

        <footer className="landing-footer">
          <div className="foundry-credit">
            Built by Qontinuum Bridge · SMTCO Foundry
          </div>
          <div className="foundry-links">
            <a href="https://smtco.co/resources" target="_blank" rel="noopener noreferrer">Related &amp; Resources</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/about" target="_blank" rel="noopener noreferrer">About</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/contact" target="_blank" rel="noopener noreferrer">Contact</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/portfolio" target="_blank" rel="noopener noreferrer">Portfolio</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
          </div>
          <div className="foundry-links">
            <a href="https://smtco.co" target="_blank" rel="noopener noreferrer">SMTCO Foundry</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/services" target="_blank" rel="noopener noreferrer">SMTCO Services</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/portfolio" target="_blank" rel="noopener noreferrer">SMTCO Portfolio</a>
            <span className="sep">·</span>
            <a href="https://smtco.co/contact" target="_blank" rel="noopener noreferrer">SMTCO Contact</a>
          </div>
          <p className="foundry-summary">
            Proud member of the SMTCO Foundry — a Qontinuum Bridge collective building web infrastructure, tools, and digital craft in Truckee, CA.{" "}
            <a href="https://smtco.co" target="_blank" rel="noopener noreferrer">smtco.co</a>
          </p>
        </footer>
      </div>
    </main>
  );
}
